// @flow

export const SUPPORT_BUTTON_FOCUS_KEY = 'SUPPORT_BUTTON_FOCUS_KEY'
export const CLOSE_BUTTON_FOCUS_KEY = 'CLOSE_BUTTON_FOCUS_KEY'
